module.exports = __webpack_public_path__ + "static/img/iberica-water.ff98484.jpg";